// Static portfolio data for Joana Pestana Ramos
// NOTE: Campaigns were migrated to MongoDB and are fetched from /api/campaigns.
// Only static profile content lives here.

export const profileData = {
  name: "Joana Pestana Ramos",
  tagline: "Brand & Growth Marketing Manager | Bridging Strategy, Commercial & Digital Performance",
  statement: "Turning complex brand challenges into growth across international markets — translating strategy into high-impact digital and in-store activations.",
  yearsExperience: 12,
  location: "France",
  email: "joanapestana.ramos@gmail.com",
  phone: "+33 (0) 614657473",
  linkedin: "https://www.linkedin.com/in/joanapr",
  cvUrl: "/cv/Joana_Pestana_Ramos_CV.pdf"
};

export const skills = {
  digital: {
    title: "Digital",
    items: ["Social Media", "Paid Media", "CRM", "Influencer Marketing", "Performance & Analytics"]
  },
  retail: {
    title: "Retail & Experience",
    items: ["Retail Activation", "POS", "Visual Merchandising", "Experiential Marketing"]
  },
  strategy: {
    title: "Strategy & Growth",
    items: ["Go-to-Market", "Brand Positioning", "Omnichannel", "Commercial Performance", "Market Expansion", "Cross-Functional Leadership"]
  }
};

export const aboutMe = {
  title: "Turning brand ambition into measurable growth",
  paragraphs: [
    "Over the past decade, I've worked with iconic brands, turning complex market challenges into campaigns that deliver real business impact. From launching a new brand with Ed Sheeran to activating high-impact partnerships with Disney and Coca-Cola, I combine creative thinking with a strong commercial and data-driven mindset.",
    "I focus on making ideas happen — translating vision into execution. Whether generating $6M in revenue from a new launch, building standout partnerships, or bringing fresh digital approaches to established brands, I bring both strategic clarity and hands-on delivery.",
    "If you're looking for a marketing leader who blends creativity, performance and execution, let's connect."
  ]
};
